/* Tax Information — the rules.
 *
 * TRANSCRIBED from Details/TaxCategoryDetails.jsx and Details/AddTaxInformation.jsx.
 */

/* Transcribed from the card's renamed headings. */
export const TAX_ROWS = [
  { key: "tax_category_title", label: "Category" },
  { key: "tax_reg_no", label: "Tax Number" },
  { key: "upload_file", label: "Supporting Document" },
];

/* Transcribed: "raised" and "pending" both read as awaiting review, alongside
   "Requested". The other three pass through to SectionStatusPill's own map. */
export const taxStatus = (record) =>
  ["raised", "pending"].includes(record?.status) ? "Requested" : record?.status;

/* Transcribed: the category select's options are the available categories,
   labelled "Title (ABBR)". */
export const categoryOptions = (available) =>
  (available || []).map((row) => ({
    value: row.categoryTitle,
    label: `${row.categoryTitle} (${row.categoryAbbr})`,
  }));

/* Transcribed: an existing record's category is shown the same way, from its
   own title and abbreviation. */
export const editingCategoryOption = (record) =>
  record?.tax_category_title
    ? {
        value: record.tax_category_title,
        label: `${record.tax_category_title} (${record.tax_abbr})`,
      }
    : null;

/* Transcribed field for field from handleSubmit's newErrors block, messages included. */
export const validateTax = ({ taxNumber, category, file, existingFile }) => {
  const errors = {};
  if (!String(taxNumber ?? "").trim()) errors.taxNumber = "Tax number is required";
  if (!category) errors.category = "Category is required";
  if (!file && !existingFile) errors.file = "Please upload supporting document";
  return errors;
};

/* Transcribed: on an edit the file field is only replaced when a NEW file was
   chosen — otherwise the stored URL is sent back unchanged. */
export const taxPayload = ({
  companyID,
  record,
  category,
  taxNumber,
  uploadedUrl,
  replacedFile,
}) => {
  if (record) {
    return {
      tax_id: record.tax_id,
      company_id: companyID,
      tax_category_title: category,
      tax_reg_no: taxNumber,
      upload_file: replacedFile ? uploadedUrl : record.upload_file,
    };
  }
  return {
    company_id: companyID,
    tax_category_title: category,
    tax_reg_no: taxNumber,
    upload_file: uploadedUrl,
  };
};

/* The tax rows as the COMPANY payload carries them. */
export const liveTaxRows = (company) =>
  (company?.company_tax || []).filter((row) => Number(row?.is_deleted) === 0);

/* A row is answered when it carries what the form requires of it: a tax number, a category and a supporting document. */
export const isTaxRowComplete = (row) =>
  Boolean(
    String(row?.tax_reg_no ?? "").trim() &&
      (row?.categoryTitle || row?.tax_category_title) &&
      row?.upload_file
  );
